import { useQuery } from '@tanstack/react-query'
import { getLastKbSync } from '@/lib/api/kb'

/** When the kb copy was last synced from Notion; `poll` speeds it up while a refresh runs. */
export function useKbLastSync({ poll }: { poll: boolean }) {
  return useQuery({
    queryKey: ['kb', 'last-sync'],
    queryFn: getLastKbSync,
    // Syncs land hourly; a minute keeps "X min ago" honest without polling.
    staleTime: 60_000,
    // While a refresh runs, check every 15 s; the sync takes about two minutes.
    refetchInterval: poll ? 15_000 : false,
  })
}
